import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import { useJsonLd, ORG_SCHEMA, WEBSITE_SCHEMA } from "@/lib/seo";

import Home from "@/pages/Home";
import DisposablePackageTracker from "@/pages/DisposablePackageTracker";
import DisposableSmartLabels from "@/pages/DisposableSmartLabels";
import SmartLabelsLogistics from "@/pages/SmartLabelsLogistics";
import HighValueShipments from "@/pages/HighValueShipments";
import PilotProjects from "@/pages/PilotProjects";
import VsReusableTrackers from "@/pages/VsReusableTrackers";
import GpsVsBleVsCellular from "@/pages/GpsVsBleVsCellular";
import HowDisposableTrackersWork from "@/pages/HowDisposableTrackersWork";
import DisposableTrackingCost from "@/pages/DisposableTrackingCost";
import Glossary from "@/pages/Glossary";
import BluetoothSmartLabels from "@/pages/BluetoothSmartLabels";
import DisposableGpsTracker from "@/pages/DisposableGpsTracker";
import GpsTrackerForPackages from "@/pages/GpsTrackerForPackages";
import FAQs from "@/pages/FAQs";
import RequestTrial from "@/pages/RequestTrial";
import About from "@/pages/About";
import NotFound from "@/pages/NotFound";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function App() {
  useJsonLd("organization", ORG_SCHEMA);
  useJsonLd("website", WEBSITE_SCHEMA);
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main className="pt-20">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/disposable-package-tracker" element={<DisposablePackageTracker />} />
            <Route path="/disposable-smart-labels" element={<DisposableSmartLabels />} />
            <Route path="/smart-labels-for-logistics" element={<SmartLabelsLogistics />} />
            <Route path="/smart-labels-for-high-value-shipments" element={<HighValueShipments />} />
            <Route path="/smart-labels-for-pilot-projects" element={<PilotProjects />} />
            <Route path="/disposable-vs-reusable-trackers" element={<VsReusableTrackers />} />
            <Route path="/gps-vs-ble-vs-cellular" element={<GpsVsBleVsCellular />} />
            <Route path="/how-disposable-trackers-work" element={<HowDisposableTrackersWork />} />
            <Route path="/disposable-tracking-cost" element={<DisposableTrackingCost />} />
            <Route path="/glossary" element={<Glossary />} />
            <Route path="/bluetooth-smart-labels" element={<BluetoothSmartLabels />} />
            <Route path="/disposable-gps-tracker" element={<DisposableGpsTracker />} />
            <Route path="/gps-tracker-for-packages" element={<GpsTrackerForPackages />} />
            <Route path="/faqs" element={<FAQs />} />
            <Route path="/request-a-trial" element={<RequestTrial />} />
            <Route path="/about" element={<About />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="bottom-right" richColors closeButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
